export default "__VITE_ASSET__CMIVnD9A__"